/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////
export { DEFAULT_PROPS } from './default-props';

/////////////////////////////////////////////
// COLOR CONFIGURATION
/////////////////////////////////////////////
export const BG_COLOR = {
  primary: 'rgba(251,248,243,1)',
  secondary: 'rgba(230,224,214,1)',
  tertiary: 'rgba(207,199,186,1)',
  alternative: '#F4F4F4',
};

export const TEXT_COLOR = {
  primary: 'rgba(92,92,92,1)',
  secondary: 'rgba(92,92,92,1)',
  tertiary: 'rgba(185,163,107,1)',
  alternative: '#000',
};

export const ASSET_PATTERN_COLOR = 'rgba(185,163,107,1)';

export const NAVIGATION_COLOR = {
  base: BG_COLOR.secondary,
  icon: TEXT_COLOR.alternative,
};

export const INPUT_COLOR = {
  background: '#ADABAC',
  color: TEXT_COLOR.tertiary,
};

export const DIVIDER_PATTERN_PROPS = {
  position: 'absolute',
  className: 'divider-pattern_cover',
  width: '100%',
  height: '110px',
  left: '0',
  overflow: 'hidden',
  zIndex: 0,
  opacity: '0.2',
};
